import * as React from "react"

import FooterNavigation from "templates/global/FooterNavigation";
import OffCanvasNavigation from "templates/global/OffCanvasNavigation";
import Icon from 'components/Icon'

const OffCanvas = ({ children, isOpen, close }) => (

	<div className={`offCanvasWrapper${isOpen ? " open" : ""}`}>
		<div className="offCanvasContent">
			{children}
		</div>
		<div className="offCanvas top">
			<div className="offCanvasMenuWrapper">
				<div className={`is-accordion`}>
					<div className="menuContent">
						<OffCanvasNavigation />
						<div className="hr-holder">
							<hr />
						</div>
						<div className="footerLinks">
							<ul className="menu vertical">
								<FooterNavigation location="offcanvas" />
								<li className={`search-li`}>
									<form action="/search/" method="GET">
										<input type="text" name="keywords" placeholder="Search" />
										<button aria-label="Search" type="submit"><Icon symbol={'search'} width="19px" height="19px" /></button>
									</form>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
)

export default OffCanvas;